import { QBankStructureDetailLayout } from '@exam-management/qbank-structure-detail';

export default function QBankStructureDetailPage() {
  return <QBankStructureDetailLayout />;
}
